<template>
  <modal ref="collectionsModal" id="collections-modal" anchor="#col" centered hide-header content-class="collectionModalRectangle">
    <template #default>
      <span class="Masthead">Add to collection</span>
      <p class="Byline">Select the collection(s) you want to add to.</p>
      <p class="Byline-Copy">Collections</p>
      <div class="collections-list">
        <rails-b-form ref="collectionsForm">
          <b-form-checkbox @change="updateCollectionsCount()" v-model="collectionsForm[collection.id]" :name="collections[collection.id]"
            :value="true" :unchecked-value="false" v-for="collection in collections" :key="collection.id">
            {{ collection.attributes.name }}
          </b-form-checkbox>
          <infinite-loading @infinite="loadMoreCollections">
            <div slot="no-more" class="loadMessage">End of collections list</div>
            <div slot="no-results" class="loadMessage">You don't have any collections yet</div>
          </infinite-loading>
        </rails-b-form>
      </div>
    </template>
    <template #modal-footer="">
      <b-button @click="submitTemplateForm()" class="mt-2" variant="primary" block>Add to {{ collectionsCount }} {{ collectionsPlural }}</b-button>
      <b-button @click="$bvModal.hide('collections-modal')" variant="secondary" block>Cancel</b-button>
    </template>

  </modal>
</template>

<script>
import Modal from '@/src/components/modal';
import RailsBForm from '@/src/components/rails_b_form.vue';

import api from "@/src/api.js";
import track from "@/src/tracking.js";

import InfiniteLoading from 'vue-infinite-loading';
import _ from 'lodash';

export default {
  props: {
    selected: {
      type: Array,
      default: []
    }
  },
  components: { RailsBForm, Modal, InfiniteLoading },
  computed: {
    collectionsPlural: function() {
      if (this.collectionsCount == 1) {
        return "Collection"
       }
       return "Collections";
    }
  },
  mounted() { 
    const vm = this;
    vm.selected.forEach(function(id) {
      vm.$set(vm.collectionsForm, id, true);
    });
  },
  watch: {
    selected: function(val) {
      const vm = this;
      val.forEach(function(id) {
        vm.$set(vm.collectionsForm, id, true);
      });
      vm.updateCollectionsCount();
    }
  },
  methods: {
    selectedCollections: function() {
      let collections = [];
      for (const [key, val] of Object.entries(this.collectionsForm)) {
        if (val == true) { collections.push(key); }
      }
      return collections;
    },
    submitTemplateForm: function() {
      this.$emit("selectCollections", this.selectedCollections());
      this.$bvModal.hide('collections-modal');
    },
    updateCollectionsCount: function() {
      this.collectionsCount = this.selectedCollections().length;
    },
    track: function() {
      track('viewer_collections_modal_viewed', {
        // TODO: Add user id, when available in VueX (PR is pending, GROW-968)
        item_id: this.$store.state.item.id,
        org_id: this.$store.state.currentOrganization.id,
      });
    },
    loadMoreCollections: function($state) {
      const vm = this;
      api.get(vm.$root.routes.api_v5_collections_path({ per_page: 20, page: vm.page })).
        then(function(response) {
          if (response.data.data.collections == undefined) {
            $state.complete();
            return;
          }
          const filtered_collections =  _.filter(response.data.data.collections, function(o) {
            if (o.attributes.onboarding === false && o.attributes.has_security === false) return o;
          });

          vm.collections.push(...filtered_collections);
          vm.page += 1;
          $state.loaded();
        });
    }
  },
  data: function() {
    return {
      collectionsForm: {},
      collectionsCount: 0,
      collections: [],
      page: 1
    }
  }
}
</script>

<style lang="scss">
@import "application.scss";

.modal-content.collectionModalRectangle {
  height: 30rem;
  padding: 0.6rem 1rem;
  border-radius: 16px;
  box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
  border: solid 0.5px #b5b5b5;
  background-color: $white;
}

.modal-body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
@import "application.scss";

.Masthead {
  width: 14.25rem;
  height: 2.375rem;
  font-family: SFPro;
  font-size: 2rem;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.Byline {
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 0.9rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Byline-Copy {
  width: 8.688rem;
  height: 1.5rem;
  margin: 1rem 1rem 1rem 0;
  font-family: SFPro;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.Combined-Shape {
  width: 2rem;
  height: 2rem;
  margin: 0 1.125rem 0 0;
  background-image: linear-gradient(340deg, #24d292 92%, #d558c8 9%);
}

.collections-list {
  position: relative;
  height: 10rem;
  overflow-y: visible;
  overflow-x: hidden;
  border-top: 1px solid #b5b5b5;

  .loadMessage {
    color: $slate-gray;
    font-size: 0.8rem;
  }
}
</style>
